import { doAjax } from './helper.js'
const initWheelSelectLogic = () => {
	//ADD RS BADGE
	const isCarRsModel = document.getElementsByName('is-car-rs-model')[0].value
	const imgSource = 'img/04_lenkrad/lenkrad_yrb_1xp_2pf/rs_badge/au513_e-tron_gt_lenkrad_yrb_1xp_2pf_rs_badge.png'
	if (isCarRsModel) {
		document.querySelectorAll('.wheel-selection img')?.forEach((element, key) => {
			let newImage = document.createElement('IMG')
			newImage.classList.add('overlay')
			newImage.id = 'badge-'+key+'-img'
			element.insertAdjacentElement('afterend', newImage)
			newImage.src = imgSource
		});
	}

	//DISABLE BUTTONS 
	let submit = document.getElementById("navigation-submit-btn");
	let options = document.querySelectorAll(".wheel-selection");
	submit.setAttribute("disabled", true);
	for (let option of options) {
		if (option.querySelector(".is-checked")) {
			submit.removeAttribute("disabled");
		}
		option.addEventListener("click", () => {
			submit.removeAttribute("disabled");
		});
	}

	//SAVE STATE 
	const steeringWheels = document.querySelectorAll('.aui-radio.aui-js-radio input')
	steeringWheels.forEach(steeringWheel => {
		steeringWheel.addEventListener('click',(element)=>{
			doAjax({
				choose_steering_wheel: element.target.value
			});
		})
	})
}
export { initWheelSelectLogic };

